// src/components/Intro.js
import React, { useState } from "react";
import "./Intro.css";
import introImage from "../assets/intro.jpg";

const Intro = () => {
  const [isFullscreen, setIsFullscreen] = useState(false);

  const handleImageClick = () => {
    // Only enable fullscreen on mobile
    if (window.innerWidth <= 768) {
      setIsFullscreen(!isFullscreen);
    }
  };

  const handleCloseFullscreen = () => {
    setIsFullscreen(false);
  };

  return (
    <>
      <section id="home" className="intro-section">
        {/* Upper Half */}
        <div className="intro-upper">
          <div className="text-left">
            <h1 className="intro-title-left">racó</h1>
          </div>
          <div className="text-right">
            <h1 className="intro-title-right">patraix</h1>
          </div>
        </div>

        {/* Lower Half - Image */}
        <div className="intro-lower">
          <img
            src={introImage}
            alt="Intro"
            className="intro-image"
            onClick={handleImageClick}
          />
        </div>
      </section>

      {/* Fullscreen Overlay */}
      {isFullscreen && (
        <div className="fullscreen-overlay" onClick={handleCloseFullscreen}>
          <div className="fullscreen-image-container">
            <img
              src={introImage}
              alt="Intro Fullscreen"
              className="fullscreen-image"
            />
          </div>
        </div>
      )}
    </>
  );
};

export default Intro;
